import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    @observable contracts;
    @observable loading = true;
    @observable error;

    constructor() {

    }

    fetchContracts(agreementData) {
        this.loading = true;
        axios.post(utils.getUrl('agreementService'), {
            loanEncypt: agreementData
        })
        .then((resp) => {
            if (!resp.data.length) {
                this.error = "Unable to retrieve data."
            }
            this.contracts = resp.data;
            this.loading = false;
        })
        .catch((error) => {
            this.error = error.message || error;
            this.loading = false;
        })
    }
}
var AgreementStore = new store;
export default AgreementStore;


// WEBPACK FOOTER //
// ./src/js/stores/AgreementStore.js